import { IS_PRO } from 'gatsby-theme-hem-store/src/constants';
import { useCustomer } from 'gatsby-theme-hem-store/src/hooks/useCustomer';
import { useShopifyStore } from 'gatsby-theme-hem-store/src/hooks/useShopifyStore';
import { useHasMounted } from 'hem-hooks';
import { Text, TextVariant } from 'hem-ui';
import { ShoppingBag } from 'lucide-react';
import React from 'react';

import { PanelEnum, usePanelStore } from '../Panels/Panels';
import { Touchable } from '../Touchable';
import { active, activeWrapper, button } from './CartLink.module.scss';

export const CartLink = () => {
  const hasMounted = useHasMounted();
  const { setCurrentlyOpenPanel } = usePanelStore();
  const { cart } = useShopifyStore();
  const customer = useCustomer((state) => state.customer);

  const openCart = () => setCurrentlyOpenPanel(PanelEnum.Cart);

  if (!hasMounted || (IS_PRO && !customer)) {
    return (
      <Touchable
        onClick={openCart}
        className={[
          button,
          'text-black transition-colors hover:text-black-600',
        ].join(' ')}
        aria-label={IS_PRO ? 'Quote' : 'Shopping bag'}
        data-selector="Navigation cart button"
      >
        <ShoppingBag size={20} />
        <span className="sr-only">Shopping bag</span>
      </Touchable>
    );
  }

  return (
    <Touchable
      onClick={openCart}
      className={[
        button,
        'text-black transition-colors hover:text-black-600',
      ].join(' ')}
      aria-label={IS_PRO ? 'Quote' : 'Shopping bag'}
      data-selector="Navigation cart button"
    >
      {(cart?.totalQuantity ?? 0) < 1 ? (
        <ShoppingBag size={20} />
      ) : (
        <span className={activeWrapper}>
          <ShoppingBag size={20} />
          <Text tag="span" variant={TextVariant.LABEL} className={active}>
            {cart?.totalQuantity ?? 0}
          </Text>
        </span>
      )}
      <span className="sr-only">Shopping bag</span>
    </Touchable>
  );
};
